const container = document.getElementById("three-container");

const scene = new THREE.Scene();
scene.background = new THREE.Color(0xffffff);

const camera = new THREE.PerspectiveCamera(
45,
window.innerWidth/window.innerHeight,
0.01,
1000
);

camera.position.set(0,0,10);

const renderer = new THREE.WebGLRenderer({
antialias:true,
alpha:true
});

renderer.setPixelRatio(window.devicePixelRatio);
renderer.setSize(
window.innerWidth,
window.innerHeight
);

container.appendChild(renderer.domElement);

const hemi = new THREE.HemisphereLight(
0xffffff,
0x666666,
3
);

scene.add(hemi);

const dir = new THREE.DirectionalLight(
0xffffff,
3
);

dir.position.set(5,5,5);

scene.add(dir);

const frontLight = new THREE.DirectionalLight(
    0xffffff,
    1
);

frontLight.position.set(
    0,
    2,
    -10
);

scene.add(frontLight);

const controls = new THREE.OrbitControls(
camera,
renderer.domElement
);

controls.enableDamping = true;
controls.target.set(0,0,0);

let bulletOut = false;
let bulletHome = null;

const loader = new THREE.GLTFLoader();

loader.load(

"https://cdn.shopify.com/3d/models/ecc91807c687d1d2/fixed_drum.glb",

function(gltf){

    console.log("PIG LOADED", gltf);

const pig = gltf.scene;

scene.add(pig);

const box = new THREE.Box3().setFromObject(pig);

const center = box.getCenter(
new THREE.Vector3()
);

pig.position.sub(center);

const size = box.getSize(
    new THREE.Vector3()
);

console.log("PIG LOADED");
console.log(size);

const maxDim = Math.max(
    size.x,
    size.y,
    size.z
);

const distance = maxDim*1.5;

if(window.innerWidth < 768){

camera.position.set(
0,
0,
-distance*1.7
);

}else{

camera.position.set(
0,
0,
-distance
);

}

camera.lookAt(0,0,0);

controls.target.set(0,0,0);

controls.update();

pig.traverse(function(child){

    if(child.isMesh){

        child.material.color.multiplyScalar(0.85);

        child.material.needsUpdate = true;

    }

});

window.pig = pig;

window.pig = pig;

const bulletLoader = new THREE.GLTFLoader();

bulletLoader.load(

"https://cdn.shopify.com/3d/models/50ef9ac5a4e1d2f6/singular_bullet.glb",

function(gltf){

    const bullet = gltf.scene;

    bullet.position.set(
        0.05,
        -0.08,
        -6.8
    );

    bullet.scale.set(
        1,
        1,
        1
    );

    pig.add(bullet);

    const bulletLight = new THREE.DirectionalLight(
    0xffffff,
    2
);

bulletLight.position.set(
    0,
    2,
    -10
);

bullet.add(bulletLight);

    const hitbox = new THREE.Mesh(
    new THREE.SphereGeometry(0.3,16,16),
    new THREE.MeshBasicMaterial({
        transparent:true,
        opacity:0
    })
);

bullet.add(hitbox);

window.bullet = hitbox;

    bullet.traverse(function(child){

    if(child.isMesh){

        child.material.side = THREE.DoubleSide;

    }

});

    bulletHome = bullet.position.clone();

let bulletHint = true;

function idleBullet(){

    if(!bulletHint) return;

    if(bulletOut) return;

    const start = bullet.position.clone();

    const end = bulletHome.clone().add(
        new THREE.Vector3(0,0,-0.4)
    );

    let progress = 0;

    function out(){

        progress += 0.08;

        if(progress > 1){

            progress = 1;

        }

        bullet.position.lerpVectors(
            start,
            end,
            progress
        );

        if(progress < 1){

            requestAnimationFrame(out);

        }else{

            let back = 0;

            function inside(){

                back += 0.08;

                if(back > 1){

                    back = 1;

                }

                bullet.position.lerpVectors(
                    end,
                    start,
                    back
                );

                if(back < 1){

                    requestAnimationFrame(inside);

                }

            }

            inside();

        }

    }

    out();

}

setInterval(function(){

    idleBullet();

},2000);

function toggleBullet(){

        const start = bullet.position.clone();

const end = bulletOut
    ? bulletHome.clone()
    : bulletHome.clone().add(new THREE.Vector3(0, 0, -10));

        bulletOut = !bulletOut;
    

        let progress = 0;

        function slide(){

            progress += 0.01;

            if(progress > 1){

                progress = 1;

            }

            bullet.position.lerpVectors(
                start,
                end,
                progress
            );

            if(progress < 1){

                requestAnimationFrame(slide);

            }

        }

        slide();

    }

  renderer.domElement.addEventListener("pointerdown", function(event){

    event.preventDefault();

    const rect = renderer.domElement.getBoundingClientRect();

    const mouse = new THREE.Vector2();

    mouse.x =
        ((event.clientX - rect.left) / rect.width) * 2 - 1;

    mouse.y =
        -((event.clientY - rect.top) / rect.height) * 2 + 1;

    const raycaster = new THREE.Raycaster();

    raycaster.setFromCamera(mouse, camera);

    const hits = raycaster.intersectObject(bullet, true);

    console.log(hits);

    if(hits.length > 0){

    bulletHint = false;

    toggleBullet();

}

});

    window.addEventListener("keydown",function(event){

        if(event.key.toLowerCase() !== "e") return;

bulletHint = false;

toggleBullet();

    });

},

undefined,

function(error){

    console.log(error);

}

);

},

undefined,

function(error){

    console.log(error);

}

);

function animate(){

    requestAnimationFrame(animate);

    controls.update();

    renderer.render(
        scene,
        camera
    );

}

animate();

window.addEventListener("resize",function(){

    camera.aspect =
    window.innerWidth / 
    window.innerHeight;

    camera.updateProjectionMatrix();

    renderer.setSize(
        window.innerWidth,
        window.innerHeight
    );

});
